import { ApiProperty } from '@nestjs/swagger';
import { IsDateString, IsEnum } from 'class-validator';
import { Expose, Type } from 'class-transformer';
import { ModerationStatus } from './moderationStatus';
import { ModerationSubjectType } from './moderationSubjectType';

export class ModerationViewModel<T extends ModerationSubjectType = ModerationSubjectType> {
  @Expose()
  @ApiProperty({ readOnly: true })
  id: number;

  @Expose()
  @ApiProperty()
  @IsDateString()
  @Type(() => Date)
  createdAt: string;

  @Expose()
  @ApiProperty()
  @IsDateString()
  updatedAt: string;

  @Expose()
  @ApiProperty({ enum: ModerationStatus })
  @IsEnum(ModerationStatus)
  status: ModerationStatus;

  @Expose()
  @ApiProperty({ enum: ModerationSubjectType })
  @IsEnum(ModerationSubjectType)
  subjectType: T;

  @Expose()
  @ApiProperty({ description: 'Сообщение клиенту' })
  message?: string;
}
